module.exports = __webpack_public_path__ + "static/media/talent_logo_en.24baf5e9.png";